var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"copy-table-data",attrs:{"role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.copyVale.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }